/**
 * My Assignments block frontend functionality
 */

document.addEventListener('DOMContentLoaded', function() {
    // Find all My Assignments blocks on the page
    const blocks = document.querySelectorAll('.wp-block-xtra-my-assignments');
    
    blocks.forEach(block => {
        const blockId = block.id;
        const config = window['myAssignmentsBlock_' + blockId.replace(/-/g, '_')];
        
        if (!config) {
            console.error('My Assignments block config not found for:', blockId);
            return;
        }
        
        // Initialize the block
        initializeMyAssignmentsBlock(block, config);
    });
});

function initializeMyAssignmentsBlock(block, config) {
    // Ensure modal exists in the DOM
    ensureModalExists();
    
    // Initialize view details buttons
    const detailButtons = block.querySelectorAll('.assignment-view-details');
    detailButtons.forEach(button => {
        button.addEventListener('click', handleViewDetails);
    });
    
    // Initialize modal close
    const modal = document.getElementById('my-assignments-details-modal');
    if (modal) {
        const closeBtn = modal.querySelector('.xtra-modal-close');
        if (closeBtn && !closeBtn.dataset.initialized) {
            closeBtn.dataset.initialized = 'true';
            closeBtn.addEventListener('click', () => {
                modal.style.display = 'none';
            });
        }
        
        // Close on outside click
        if (!modal.dataset.initialized) {
            modal.dataset.initialized = 'true';
            modal.addEventListener('click', (event) => {
                if (event.target === modal) {
                    modal.style.display = 'none';
                }
            });
        }
    }
    
    // Handle post selection
    block.querySelectorAll('.post-selector').forEach(select => {
        select.addEventListener('change', function() {
            const assignmentId = this.dataset.assignmentId;
            const submitButton = block.querySelector(`.submit-assignment[data-assignment-id="${assignmentId}"]`);
            if (submitButton) {
                submitButton.disabled = !this.value;
            }
        });
    });
    
    // Handle submit assignment
    block.querySelectorAll('.submit-assignment').forEach(button => {
        button.addEventListener('click', async function() {
            if (this.disabled) return;
            
            const assignmentId = this.dataset.assignmentId;
            const select = block.querySelector(`.post-selector[data-assignment-id="${assignmentId}"]`);
            const postId = select ? select.value : null;
            
            if (!postId) {
                alert('Please select a post to submit.');
                return;
            }
            
            this.disabled = true;
            this.textContent = 'Submitting...';
            
            try {
                const response = await fetch(`/wp-json/${config.apiNamespace}/assignments/${assignmentId}/submit`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-WP-Nonce': window.XXRest?.nonce || config.nonce
                    },
                    body: JSON.stringify({
                        post_id: parseInt(postId)
                    })
                });
                
                const data = await response.json();
                
                if (response.ok && data.success) {
                    // Update UI or reload
                    const card = this.closest('.assignment-card') || this.closest('tr');
                    if (card) {
                        const statusElement = card.querySelector('.assignment-status');
                        if (statusElement) {
                            statusElement.textContent = 'Submitted';
                            statusElement.className = 'assignment-status status-submitted';
                        }
                        
                        // Update actions container while keeping View Details button
                        const actionsContainer = card.querySelector('.assignment-actions');
                        if (actionsContainer) {
                            // Keep the View Details button
                            const viewDetailsBtn = actionsContainer.querySelector('.assignment-view-details');
                            
                            // Clear the container
                            actionsContainer.innerHTML = '';
                            
                            // Re-add the View Details button first
                            if (viewDetailsBtn) {
                                actionsContainer.appendChild(viewDetailsBtn);
                            }
                            
                            // Add the status message
                            const statusMessage = document.createElement('p');
                            statusMessage.className = 'status-message';
                            statusMessage.textContent = 'Awaiting review';
                            actionsContainer.appendChild(statusMessage);
                        }
                    }
                    
                    showNotification('Assignment submitted successfully!', 'success');
                } else {
                    throw new Error(data.error || 'Failed to submit assignment');
                }
            } catch (error) {
                console.error('Error submitting assignment:', error);
                showNotification(error.message || 'Failed to submit assignment', 'error');
                this.disabled = false;
                this.textContent = 'Submit';
            }
        });
    });
    
    // Handle abandon assignment
    block.querySelectorAll('.abandon-assignment').forEach(button => {
        button.addEventListener('click', async function() {
            const assignmentId = this.dataset.assignmentId;
            const originalText = this.textContent;
            
            // Check if we're in confirmation mode
            if (this.classList.contains('confirm-abandon')) {
                // Second click - actually abandon
                this.disabled = true;
                this.textContent = 'Abandoning...';
                
                try {
                    const response = await fetch(`/wp-json/${config.apiNamespace}/assignments/${assignmentId}/abandon`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-WP-Nonce': window.XXRest?.nonce || config.nonce
                        }
                    });
                    
                    const data = await response.json();
                    
                    if (response.ok && data.success) {
                        // Remove the assignment card/row
                        const card = this.closest('.assignment-card') || this.closest('tr');
                        if (card) {
                            card.style.opacity = '0.5';
                            card.style.transition = 'opacity 0.3s ease';
                            setTimeout(() => {
                                card.remove();
                                
                                // Check if no assignments left
                                const remainingCards = block.querySelectorAll('.assignment-card, .assignments-table tr');
                                if (remainingCards.length === 0) {
                                    location.reload(); // Reload to show "no assignments" message
                                }
                            }, 300);
                        }
                    } else {
                        throw new Error(data.error || 'Failed to abandon assignment');
                    }
                } catch (error) {
                    console.error('Error abandoning assignment:', error);
                    showNotification(error.message || 'Failed to abandon assignment', 'error');
                    this.disabled = false;
                    this.textContent = originalText;
                    this.classList.remove('confirm-abandon');
                }
            } else {
                // First click - enter confirmation mode
                this.classList.add('confirm-abandon');
                this.textContent = 'Confirm Abandon?';
                
                // Clear any existing timeout
                if (this.abandonTimeout) {
                    clearTimeout(this.abandonTimeout);
                }
                
                // Reset after 3 seconds if not confirmed
                this.abandonTimeout = setTimeout(() => {
                    this.classList.remove('confirm-abandon');
                    this.textContent = originalText;
                }, 3000);
            }
        });
    });
    
    // Handle extend deadline
    block.querySelectorAll('.extend-deadline').forEach(button => {
        button.addEventListener('click', async function() {
            const assignmentId = this.dataset.assignmentId;
            this.disabled = true;
            const originalText = this.textContent;
            this.textContent = 'Extending...';
            
            try {
                const response = await fetch(`/wp-json/${config.apiNamespace}/assignments/${assignmentId}/extend`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-WP-Nonce': window.XXRest?.nonce || config.nonce
                    }
                });
                
                const data = await response.json();
                
                if (response.ok && data.success) {
                    // Update deadline display
                    const card = this.closest('.assignment-card') || this.closest('tr');
                    if (card && data.new_deadline) {
                        const deadlineElement = card.querySelector('.deadline');
                        if (deadlineElement) {
                            const newDate = new Date(data.new_deadline);
                            const formattedDate = newDate.toLocaleString('en-US', {
                                month: 'short',
                                day: 'numeric',
                                hour: 'numeric',
                                minute: '2-digit',
                                hour12: true
                            });
                            
                            // Update deadline text
                            const deadlineText = deadlineElement.querySelector('strong');
                            if (deadlineText && deadlineText.nextSibling) {
                                deadlineText.nextSibling.textContent = ' ' + formattedDate;
                            }
                            
                            // Remove urgent/overdue classes if present
                            deadlineElement.classList.remove('warning');
                            const urgentLabel = deadlineElement.querySelector('.urgent-label, .overdue-label');
                            if (urgentLabel) {
                                urgentLabel.remove();
                            }
                        }
                        
                        // Add extension used indicator
                        const metaContainer = card.querySelector('.assignment-meta');
                        if (metaContainer && !card.querySelector('.extension-used')) {
                            const extensionIndicator = document.createElement('div');
                            extensionIndicator.className = 'meta-item';
                            extensionIndicator.innerHTML = '<span class="extension-used">Extension used</span>';
                            metaContainer.appendChild(extensionIndicator);
                        }
                    }
                    
                    // Remove the extend button
                    this.remove();
                    
                    showNotification('Deadline extended by 12 hours!', 'success');
                } else {
                    throw new Error(data.error || 'Failed to extend deadline');
                }
            } catch (error) {
                console.error('Error extending deadline:', error);
                showNotification(error.message || 'Failed to extend deadline', 'error');
                this.disabled = false;
                this.textContent = originalText;
            }
        });
    });
}

// Ensure modal exists in the DOM
function ensureModalExists() {
    // Check if modal already exists
    if (document.getElementById('my-assignments-details-modal')) {
        return;
    }
    
    // Create modal HTML
    const modalHtml = `
        <div id="my-assignments-details-modal" class="xtra-modal" style="display: none;">
            <div class="xtra-modal-content">
                <span class="xtra-modal-close">&times;</span>
                <div class="modal-header">
                    <h2 class="modal-title"></h2>
                </div>
                <div class="modal-body">
                    <!-- Content will be populated by JavaScript -->
                </div>
            </div>
        </div>
    `;
    
    // Append to body
    document.body.insertAdjacentHTML('beforeend', modalHtml);
}

// Helper function to show notifications
function showNotification(message, type = 'info') {
    // Use XtraXtra toast notifications if available
    if (window.XtraXtraToast && typeof window.XtraXtraToast.show === 'function') {
        window.XtraXtraToast.show(message, type);
        return;
    }
    
    // Fallback: dispatch custom event for toast system
    const event = new CustomEvent('xtraxtra:notify', {
        detail: { message, type }
    });
    document.dispatchEvent(event);
    
    // Final fallback to console
    console.log(`[${type}] ${message}`);
}

// Handle View Details button click
async function handleViewDetails(e) {
    e.preventDefault();
    const button = e.currentTarget;
    const assignmentId = button.dataset.assignmentId;
    
    if (!assignmentId) return;
    
    // Get the assignment card for basic info
    const card = button.closest('.assignment-card');
    const title = card.querySelector('h3').textContent;
    const excerpt = card.querySelector('.assignment-excerpt')?.innerHTML || '';
    const metaItems = card.querySelectorAll('.assignment-meta .meta-item');
    
    // Build details HTML from meta items
    let detailsHtml = '<div class="meta-details-grid">';
    metaItems.forEach(item => {
        // Skip extension-used items as they're just indicators
        if (!item.querySelector('.extension-used')) {
            detailsHtml += `<div class="assignment-meta-item">${item.innerHTML}</div>`;
        }
    });
    detailsHtml += '</div>';
    
    // Get the modal
    const modal = document.getElementById('my-assignments-details-modal');
    if (!modal) return;
    
    const modalTitle = modal.querySelector('.modal-title');
    const modalBody = modal.querySelector('.modal-body');
    
    // Set title and show loading
    modalTitle.textContent = title;
    modalBody.innerHTML = '<p style="text-align: center; padding: 40px;">Loading assignment details...</p>';
    modal.style.display = 'block';
    
    try {
        // Fetch full post content from WordPress API
        const response = await fetch(`/wp-json/wp/v2/xtra-assignments/${assignmentId}`);
        if (!response.ok) throw new Error('Failed to load assignment details');
        
        const post = await response.json();
        
        // Populate modal with full content
        modalBody.innerHTML = `
            <div class="assignment-full-content">
                ${post.content.rendered || '<p>No detailed description available.</p>'}
            </div>
            <div class="assignment-meta-details">
                <h3>Assignment Details</h3>
                ${detailsHtml}
            </div>
            <div class="assignment-instructions">
                <h3>Submission Instructions</h3>
                <ol>
                    <li>Select your completed article from the dropdown menu</li>
                    <li>Click the Submit button to send it for review</li>
                    <li>Wait for editorial feedback</li>
                    <li>If revisions are requested, make changes and resubmit</li>
                    <li>Receive your MyBucks bonus upon approval</li>
                </ol>
            </div>
        `;
    } catch (error) {
        console.error('Error loading assignment details:', error);
        // If API fails, use the excerpt as fallback
        modalBody.innerHTML = `
            <div class="assignment-full-content">
                ${excerpt || '<p>Assignment details could not be loaded.</p>'}
                <p style="color: #999; font-style: italic; margin-top: 1rem;">Full details could not be loaded. Please try refreshing the page.</p>
            </div>
            <div class="assignment-meta-details">
                <h3>Assignment Details</h3>
                ${detailsHtml}
            </div>
            <div class="assignment-instructions">
                <h3>Submission Instructions</h3>
                <ol>
                    <li>Select your completed article from the dropdown menu</li>
                    <li>Click the Submit button to send it for review</li>
                    <li>Wait for editorial feedback</li>
                    <li>If revisions are requested, make changes and resubmit</li>
                    <li>Receive your MyBucks bonus upon approval</li>
                </ol>
            </div>
        `;
    }
}